import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { BaseApiService } from '../base.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserJobBookmarkService extends BaseApiService {
  constructor(http: HttpClient) {
    const apiBaseUrl = isDevMode() ? '/navigate-api' : environment.navigateApiUrl;
    super(http, apiBaseUrl);
  }

  addRemoveBookmarkedJob(jobPosting: any, status: 'ADD' | 'REMOVE'): Observable<any> {
    const payload = { 
      job_posting: jobPosting,
      status: status 
    };
    return this.post<any>('job-posting-bookmark', payload);
  }
}
